import { authApiCall } from '../../auth/saga';

export const getUsedCoupons = params =>
  authApiCall({
    url: '/coupons/accept-reject-coupon/',
    method: 'get',
    params,
  });
